import { memo } from 'react';

import ExcelTableIconSVG from '@/assets/excel-table-icon.svg?react';
import { Icon, IconProps } from '@/components/core';

const IExcelTableIcon = (props: Omit<IconProps, 'SVGComponent'>) => (
  <Icon SVGComponent={ExcelTableIconSVG} {...props} />
);

export const ExcelTableIcon = memo(IExcelTableIcon) as typeof IExcelTableIcon;
